var React = require('react');

function WindowsInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M61.51 9.857H1V56.45h60.51V9.857Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M12.191 6.53V1h58.263v47.694H64.85M1 18.735h60.49M11.078 14.306H6.585M20.043 14.306h-4.492M29.009 14.306h-4.493","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

WindowsInline.defaultProps = {"width":"72","height":"58","fill":"none"};

module.exports = WindowsInline;

WindowsInline.default = WindowsInline;
